var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasV4)?_c('SearchReborn'):_c('SearchLegacy',{ref:"legacy"})}
var staticRenderFns = []

export { render, staticRenderFns }